import styled from 'styled-components'
import { SegmentedBar } from '@components/Segmented'

export const TabBar = styled(SegmentedBar)`
	margin-bottom: 16px;
`

export { SegmentedOption as TabButton } from '@components/Segmented'
